module.exports = __webpack_public_path__ + "media/images/icons/ic-specialist-area-714794f1b91b03e38658ef138abc8590.svg";